export const generalSettingsSchema = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'botConfigSettingsSchema.json',
  type: 'object',
  properties: {
    name: {
      type: 'string',
      title: 'Bot name'
    },
    previewUrl: {
      type: 'string',
      title: 'Default preview URL',
      description: 'Link to webchat of bot where deploys of this tree goes to',
      default: ''
    },
    powerbiEmbedUrl: {
      type: 'string',
      title: 'PowerBI embed URL'
    },
    designerTheme: {
      type: 'object',
      title: 'Designer theme',
      properties: {
        primaryColor: {
          type: 'string',
          title: 'Background color',
          description:
            "Set the background color of the Designer. It will help you differentiate individual bots from each other. It won't affect bots appearance.",
          default: '#'
        }
      }
    }
  }
} as const

export const uiSchema = {
  designerTheme: {
    primaryColor: { 'ui:widget': 'ColorPaletteWidget' },
    'ui:classNames': 'e2e-designerTheme',
    'ui:options': { label: false }
  }
} as const
